import { useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { IoMdAlert } from "react-icons/io";
import { GoAlert } from "react-icons/go";
import { IoShieldCheckmark } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../../statics/logo/logo-cpurls.svg";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { checkLink, resetPassword } from "../../../store/recover";
type FormValues = {
  new_password: string;
  re_password: string;
};

const Formchange = () => {
  const { key } = useParams();
  const { code, status } = useAppSelector((state) => state.recover);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<FormValues>();
  const con_pass = watch("new_password");
  const onSubmit: SubmitHandler<FormValues> = (data) => {
    dispatch(resetPassword({ code, ...data }));
  };

  useEffect(() => {
    dispatch(checkLink(key ? key : ""));
  }, []);

  if (status === "checkLink_loading") {
    return <h2>Cargando....</h2>;
  }
  if (status === "checkLink_rejected") {
    return (
      <div className="c-info-message">
        <span className="c-info-message__icon c-info-message__icon--danger">
          <GoAlert />
        </span>
        <span className="c-info-message__title">
          Failed password reset request!
        </span>
        <span className="c-info-message__description">
          An error ocurred while we processed <br />
          your password reset request
        </span>
        <button
          className="c-info-message__button"
          onClick={() => navigate("/forgotpassword")}
        >
          Plase try again later
        </button>
      </div>
    );
  }

  if (status === "resetPassword_success") {
    return (
      <div className="c-info-message">
        <span className="c-info-message__icon c-info-message__icon--success">
          <IoShieldCheckmark />
        </span>
        <span className="c-info-message__title">Passwword Updated!</span>
        <span className="c-info-message__description">
          Your password has been changed successfully <br />
          User your new password to login.
        </span>
        <button
          className="c-info-message__button"
          onClick={() => navigate("/")}
        >
          Login Now
        </button>
      </div>
    );
  }
  return (
    <form className="c-change-left__form" onSubmit={handleSubmit(onSubmit)}>
      <img className="c-change-left__logo" src={logo} alt="PURLs logo" />
      <span className="c-change-left__title">Set-up your new Password</span>
      <label className="c-change-left__description">
        Enter your new password and re-enter below.
      </label>

      <div className="c-change-left__box-input">
        <label className="c-change-left__text-input">New Password</label>
        <input
          className="c-change-left__input"
          type="password"
          {...register("new_password", {
            required: "password is required",
            minLength: {
              value: 8,
              message: "Password must have at least 8 characters",
            },
          })}
        />
        {errors.new_password ? (
          <label className="c-login-left__text-alert">
            {errors.new_password?.message}
          </label>
        ) : null}
      </div>
      <div className="c-change-left__box-input">
        <label className="c-change-left__text-input">
          Re-type New Password
        </label>
        <input
          className="c-change-left__input"
          type="password"
          {...register("re_password", {
            validate: (value) =>
              value === con_pass || "the password does not match",
          })}
        />
        {errors.re_password ? (
          <label className="c-login-left__text-alert">
            {errors.re_password?.message}
          </label>
        ) : null}
      </div>
      {status === "resetPassword_rejected" && (
        <div className="c-alert--danger">
          <IoMdAlert />
          <span>
            Oops, an error occurred when trying to change your password
          </span>
        </div>
      )}
      <div className="c-change-left__box-buttons">
        <button
          type="submit"
          className={`c-change-left__button-submit ${
            status === "resetPassword_loading" &&
            `c-change-left__button-submit--disabled`
          }`}
        >
          {status === "resetPassword_loading" ? (
            <>
              <div className="spiner"></div> Loading...
            </>
          ) : (
            <>Submit</>
          )}
        </button>
        <button
          type="button"
          className="c-change-left__button-cancel"
          onClick={() => navigate("/")}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default Formchange;
